import React, { useCallback, useState } from 'react';
import Link from '@repo/ui/components/buttons/Link';

import { api as API } from '../../mixins/api';

import AlertBlock from '../widgets/AlertBlock';

import SoloContent from '@repo/ui/components/content/onboarding/SoloContent';
import Panel from '@repo/ui/components/layout/Panel';
import Buttons from '@repo/ui/components/buttons/index';
import { Form, FormActions, FormControl } from '@repo/ui/components/inputs/Form';
import { Paragraph } from '@repo/ui/components/typography/Content';
import EmailInput from '@repo/ui/components/inputs/EmailInput';
import { usePageTitle } from '../../utils/Hooks';
import { useTranslation } from 'react-i18next';

export default function ForgotPassword({}) {
  const { t } = useTranslation(['common', 'commonPlat']);
  const [success, setSuccess] = useState(false);
  usePageTitle(t('common:nav.resetPassword'));

  const handleSubmit = useCallback(({ email }, _, __, hsr) => {
    API.makeRequest(
      '/user/forgot-password',
      'POST',
      {
        email,
      },
      hsr((res) => {
        if (res) {
          setSuccess(true);
        }
      }),
    );
  }, []);

  return (
    <SoloContent>
      <Panel>
        {success ? (
          <AlertBlock
            icon="envelope"
            title={t('common:labels.success')}
            text={t('common:alerts.resetInstructionsSentInbox')}
            style="success"
          />
        ) : (
          <Paragraph>{t('common:labels.forgotPasswordIntro')}</Paragraph>
        )}

        <Form
          id="reset-password"
          onSubmit={handleSubmit}
          onChange={() => success && setSuccess(false)}
        >
          <FormControl label={t('commonPlat:labels.emailAddress')}>
            <EmailInput id="email" required />
          </FormControl>

          <FormActions
            alternateActions={
              <>
                {t('common:labels.rememberedQues')}
                <br />
                <Link to="/login">{t('common:actions.signInExcl')}</Link>
              </>
            }
          >
            <Buttons.Primary type="submit" disabled={success}>
              {t('commonPlat:actions.submit')}
            </Buttons.Primary>
          </FormActions>
        </Form>
      </Panel>
      <p className="text-center text-muted mt-md mb-md">
        © {new Date().getFullYear()} Do Some Good Impact Technologies Inc. All Rights Reserved.
      </p>
    </SoloContent>
  );
}
